// ErrorBoundary.js
import React, { Component } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

// Functional ErrorBoundary component to use hooks
const ErrorBoundary = ({ children }) => {
  const navigate = useNavigate(); // Get the navigate function
  const [hasError, setHasError] = React.useState(false);

  React.useEffect(() => {
    const errorHandler = (error, info) => {
      setHasError(true);
      console.error('Error caught by ErrorBoundary:', error, info);
    };

    // Adding global error handling (optional)
    window.onerror = errorHandler;

    return () => {
      // Cleanup on unmount
      window.onerror = null;
    };
  }, []);

  if (hasError) {
    navigate('/pg/error'); // Navigate to error page
    return null;
  }

  return children; // Render the wrapped children components if no error
};

export default ErrorBoundary;
